<script>
	import listBase from '@_system/components/base/list.vue'
	import settlementtree from '../lib/datetree/tree.vue'
	import receiptIndex from '../current/lib/receipt/index.vue'
	import schedulingIndex from './lib/scheduling/index.vue'
	import orderdetailIndex from './lib/orderdetail/index.vue'
	export default {
		extends: listBase,
		name: 'reconciliationpayIndex',
		render(h) {
			this.$slots.aside = [ 
				<settlementtree ref = "settlementtree"key = {this.settlementtreeKey} onSelect = {this.settlementtreeChange}/>
			]
			this.$slots.plug = [
				<receipt-index ref="receiptBox" receiptType="FK" receiptInfo={this.receiptInfo} row={this.currentrow} />,
				<scheduling-index ref="scheduling" onShowdetail={this.showdetail} />,
				<orderdetail-index ref="orderdetail" type={this.detailType} data={this.orderDetailData} detailTitle={this.detailTitle} onModalhide={this.orderdetailHide} />
			]			
			this.$slots.header = [
				<el-breadcrumb separator-class="el-icon-arrow-right" >
					{
						this.parentbread.length!=0?this.parentbread.map((item,index)=>{
						return <el-breadcrumb-item key={index}>{item.name}</el-breadcrumb-item>
					}):<el-breadcrumb-item>{'月结对账'}</el-breadcrumb-item>
					
					}			
				</el-breadcrumb>
			]
			return listBase.render.call(this, h)
		},
		props: {

		},
		data() {
			return {
				moduleName: 'reconciliation_pay',
				windowName: '月结付款单',
				windowType: 'modal',
				settlementtreeKey: Math.random(),
				nodeid: [],
				parentbread: [],
				currentrow: null,
				currentrcvinfo: null,
				currentpayinfo:null,
				receiptInfo: null,	
				orderDetailData:null,
				detailType:'unpay',
				detailTitle:null
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			beforeCreateGrid(formConfig,columns){
				columns.forEach((item)=>{
					if(item.field == 'invoicewriteoff'){
						item.align = 'center'
						item.cellRender = {
							name:'$switch',
							enabled:true,
							props:{
								openLabel:'是',
								closeLabel:'否',
								openValue:5,
								closeValue:6,
								size:'medium',
							},
							events:{
								change:({row})=>{
									this.switchChnage(row)
								}
							}
						}
					}
					if(item.field == 'incode'){
						item.slots = {
							default({row}){
								return <el-link type="primary" style="font-size:12px;">{row.incode}</el-link>
							}
						}
					}
				})
			},
			cellClick(e) {
				
				if(e.column.field=='incode'){
					window.open('https://wz-nazhi.com/H5/#/home?billCode='+e.row.incode, '_blank');
				}
			},
			switchChnage(row){
				this.$api.reconciliation_pay.updatefromlist(row.id,{invoicewriteoff:row.invoicewriteoff})
			},
			// payment(row) {
			// 	this.currentrow = row
			// 	console.log(row)
			// 	if (row.paymentamount >= 1000) {
			// 		this.$message.error('付款金额不能大于1000')
			// 		return
			// 	}
			// 	let handle = this.$loading()
			// 	this.$api.reconciliationcurrent.getPaymentInfo({
			// 		supplierwlnid: row.wlnid
			// 	}).then((res) => {
			// 		this.$loadingclose(handle)
			// 		let payinfo = res.queryAccount[0]
			// 		let rcvinfo = res.supplierInfo
			// 		this.currentrcvinfo = rcvinfo
			// 		this.currentpayinfo = payinfo
			// 		let str = [
			// 			'付款方：' + payinfo.accName,
			// 			'付款账号：' + payinfo.bankAcc,
			// 			'余额：' + payinfo.availBal,
			// 			'------------------------------------------',
			// 			'收款方：' + rcvinfo.rcvName,
			// 			'收款账号：' + rcvinfo.rcvAcc,
			// 			'开户行：' + rcvinfo.rcvBankName,
			// 			'付款金额：' + row.paymentamount,
			// 		]
			// 		this.$confirm(str.join('</br>'), '付款信息', {
			// 			dangerouslyUseHTMLString: true,
			// 			confirmButtonText: '确定',
			// 			cancelButtonText: '取消',
			// 			type: 'warning',
			// 			beforeClose: this.beforePaySubmit
			// 		}).then(() => {

			// 		}).catch(() => {

			// 		});
			// 	})
			// },
			beforePaySubmit(action, instance, done) {
				console.log(action)
				if (action == 'confirm' && this.currentrow) {
					//if(this.currentrcvinfo.rcvName  &&  this.currentrcvinfo.rcvAcc  && this.currentrcvinfo.rcvAcc){
					let handle = this.$loading()
					this.$api.reconciliationcurrent.payment({
						billid: this.currentrow.id,
						supplierwlnid: this.currentrow.wlnid,
						payaccount: this.currentpayinfo.bankAcc,
						type: 'FK'
					}).then(() => {
						done()
						this.$loadingclose(handle)
						this.$message.success('操作成功')
					}, () => {
						this.$loadingclose(handle)
					})
					// }else{
					// 	this.$message.error('请完善供应商收款信息')
					// }
				} else {
					done()
				}
			},
			receipt(row) {
				console.log(row)
				this.currentrow = row
				let handle = this.$loading()
				this.$api.reconciliationcurrent.getReceiptInfo({
					supplierwlnid: row.wlnid,
					id: row.id,
					type: 'FK'
				}).then((res) => {
					this.receiptInfo = res
					this.$loadingclose(handle)
					this.$refs.receiptBox.modalShow()
					
				},()=>{
					this.$loadingclose(handle)
				})
			},
			settlementtreeChange(e) {
				this.parentbread = []
				this.nodeid = e.parentid != 0? [e.id]:e.childrenid
				if(e.parentid!=0){
					this.parentbread.push({id:e.parentid,name:e.parentid})
				}
				this.parentbread.push({id:e.id,name:e.name})
				
					// this.gridOptions.pagerConfig = {
					// 	currentPage: 1,
					// 	pageSize: 20,
					// }
				this.customreload()
			},
			beforeRequest(form) {
				form.nodeid = this.nodeid
			},
			scheduling() {
				this.$refs.scheduling.modalShow()
			},
			showdetail(e){
				this.detailTitle = e.detailTitle
				this.detailType = e.type
				this.orderDetailData = e.data
				this.$refs.orderdetail.modal_show()
			},
			orderdetailHide(){
				this.$refs.scheduling.init()
			}
		},
		components: {
			settlementtree,
			receiptIndex,
			schedulingIndex,
			orderdetailIndex
		}
	}
</script>